import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty, toArray } from 'lodash'
import { Button, Table, Input } from '@driftt/tide-core-legacy'
import Fuse from 'fuse.js'

import { nonBotUsers } from 'app/modules/user/selectors'
import RowFormatter from './RowFormatter'
import { AddTeamMembersColumns, FuseOptions } from './constants'

import './style.styl'

class MemberSelectorTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      bulkSelected: false,
      users: props.users || [],
      selectedMembers: this.props.teamMembers || [],
      usersCorpus: new Fuse(toArray(props.users), FuseOptions),
      isSaving: false,
    }
  }

  onUserSelected = user => {
    const selectedMemberIds = this.state.selectedMembers.map(x => x.id)

    const newSelectedMembers = selectedMemberIds.includes(user.id)
      ? this.state.selectedMembers.filter(member => member.id !== user.id)
      : [...this.state.selectedMembers, user]

    this.setState({ selectedMembers: newSelectedMembers })
  }

  onBulkSelectChecked = value => {
    const { users } = this.props
    const selectedMembers = value ? toArray(users) : []

    this.setState({ bulkSelected: value, selectedMembers })
  }

  onSearchInputChange = searchTerm => {
    const { users } = this.props
    const { usersCorpus } = this.state
    const value = searchTerm.target.value

    if (isEmpty(value)) {
      this.setState({ users: users })
    } else {
      const searchResults = usersCorpus.search(value)
      this.setState({ users: searchResults })
    }
  }

  onAddToTeam = () => {
    const { selectedMembers } = this.state
    this.setState({
      isSaving: true,
    })
    setTimeout(() => {
      this.props.onSave(selectedMembers)
    }, 500)
  }

  renderCheckSelectAll = () => (
    <Input
      className="team-members-modal-select-all"
      type="checkbox"
      checked={this.state.bulkSelected}
      onChange={this.onBulkSelectChecked}
    />
  )

  render() {
    const { selectedMembers, isSaving, users } = this.state

    return (
      <div className="team-name-content">
        <div className="team-members-modal-search">
          <Input
            className="team-members-modal-search-input"
            placeholder="Search users"
            onChange={this.onSearchInputChange}
            type="search"
          />
        </div> 
        <div className="team-member-selector-table">
          <Table
            className="team-members-table"
            columns={AddTeamMembersColumns({ bulkSelect: this.renderCheckSelectAll })}
            data={RowFormatter({
              users: users,
              onUserSelect: this.onUserSelected,
              selectedMembers: selectedMembers,
            })}
          />
        </div>
        <div className="team-members-modal-button-container">
          <Button
            disabled={!selectedMembers.length || isSaving}
            onClick={this.onAddToTeam}
            loading={isSaving}
          >
            {!!selectedMembers.length ? `Save teammates` : 'Select team'}
          </Button>
          <Button type="tertiary" onClick={this.props.onCancel}>
            Go back
          </Button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  users: nonBotUsers(state).toJS(),
})

export default connect(mapStateToProps)(MemberSelectorTable)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/MemberSelectorTable/index.js